<template>
	<section class="pre-footer">
		<div class="row small-row">
			<div class="columns column4 align-left">
				<h2>{{ footerSection.header }}</h2>
				<div v-parse-links v-html="footerSection.content" />
			</div>
		</div>
		<picture>
			<source v-if="footerSection.imageWebp" :srcset="footerSection.imageWebp" type="image/webp" />
			<source :srcset="footerSection.image" />
			<img :src="footerSection.image" class="bg-image" loading="lazy" :alt="footerSection.imageAlt" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	footerSection: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.pre-footer {
	position: relative;

	.column4 {
		margin: 100px 0;
		background: #fff;
		padding: 40px;
		box-shadow: 0 15px 25px rgb(0 0 0 / 10%);
		position: relative;
		z-index: 2;
	}
}

.bg-image {
	position: absolute;
	inset: 0;
	height: 100%;
	width: 100%;
	object-fit: cover;
	z-index: 1;
}

@media (max-width: 900px) {
	.pre-footer {
		.column4 {
			width: 58%;
		}
	}
}

@media (max-width: 600px) {
	.pre-footer {
		.column4 {
			width: 82%;
			margin: 120px auto;
		}
	}
}
</style>
